import type { ExcursionCardProps } from "@op/puck-types";
import { Print_Dc_Excursion_Card } from "@op/sf-op";
import { useTranslation } from "@op/utils";

export const ExcursionCard = ({ excursion, onClick }: ExcursionCardProps) => {
  const { excursionCard } = useTranslation();

  return (
    <a href={`#excursion-${excursion.slug}`}>
      <Print_Dc_Excursion_Card
        style={{
          breakInside: "avoid-page",
        }}
        onClick={onClick}
        heading={excursion.title}
        subtitle={`${excursionCard.see} ${excursion.overline}`}
      />
    </a>
  );
};

export default ExcursionCard;
